import { makeApiRequest } from 'actions/api';
import {
  refreshBaskets as refreshBasketsLegacy,
  getBasket as getBasketLegacy,
} from 'actions/baskets';
import { refreshBehavioralDiscounts } from 'actions/behavioralDiscounts';
import {
  GET_BASKET_V3,
  BASKET_SUMMARY_V3,
  GET_VIEWABLE_BASKETS_V3,
  SKIP_BASKET_V3,
  UNSKIP_BASKET_V3,
  UPDATE_BASKET_V3,
  GET_BASKET_MENU_MEAL_V3,
} from 'lib/constants/v3Actions';
import * as fromV3Dashboard from 'reducers/v3/dashboard';
import RequestService from 'services/RequestService';

// menuSlug not used in request to API but is used for redux
export const getBasket = (basketSlug, menuSlug) =>
  makeApiRequest({
    requestType: GET_BASKET_V3,
    method: RequestService.v3.getBasket,
    params: { basketSlug, menuSlug },
  });

export const getBasketSummary = menuSlug =>
  makeApiRequest({
    requestType: BASKET_SUMMARY_V3,
    method: RequestService.v3.getBasketSummary,
    params: { menuSlug },
  });

export const getViewableBaskets = () =>
  makeApiRequest({
    requestType: GET_VIEWABLE_BASKETS_V3,
    method: RequestService.v3.getViewableBaskets,
  });

export const skipBasket = (menuSlug, cta) => {
  return async dispatch => {
    const response = await dispatch(
      makeApiRequest({
        requestType: SKIP_BASKET_V3,
        method: RequestService.skipBasket,
        params: { menuSlug },
        metadata: { cta },
      })
    );
    if (response.ok) {
      dispatch(refreshBehavioralDiscounts(menuSlug));
      dispatch(refreshBaskets(menuSlug));
      dispatch(getBasketLegacy(menuSlug));
      dispatch(refreshBasketsLegacy(menuSlug));
    }
    return response;
  };
};

export const unskipBasket = (menuSlug, cta, isUnskipViaSlideout = false, mealId = null) => {
  return async dispatch => {
    const params = { menuSlug, mealId, cta, isUnskipViaSlideout };
    const response = await dispatch(
      makeApiRequest({
        requestType: UNSKIP_BASKET_V3,
        method: RequestService.unskipBasket,
        params,
        metadata: { cta },
      })
    );
    if (response.ok) {
      if (isUnskipViaSlideout) {
        await dispatch(getBasketSummary(menuSlug));
      }
      dispatch(refreshBehavioralDiscounts(menuSlug));
      dispatch(refreshBaskets(menuSlug));
      dispatch(getBasketLegacy(menuSlug));
      dispatch(refreshBasketsLegacy(menuSlug));
    }
    return response;
  };
};

export const refreshBaskets = menuSlug => async (dispatch, getState) => {
  const state = getState();
  const menuSlugs = fromV3Dashboard.selectMenuSlugs(state);
  const menusToFetch = menuSlugs.slice(menuSlugs.indexOf(menuSlug) + 1);
  const filteredMenusToFetch = menusToFetch.filter(slug => {
    const basket = fromV3Dashboard.selectBasket(state, slug);
    // deliveryDay is non-existent on unloaded baskets
    return basket.deliveryDay;
  });

  return await Promise.all(
    filteredMenusToFetch.map(menuSlug => dispatch(getBasketSummary(menuSlug)))
  );
};

export const updateBasket = (basketSlug, menuSlug, payload) => {
  return async dispatch => {
    const response = await dispatch(
      makeApiRequest({
        requestType: UPDATE_BASKET_V3,
        method: RequestService.v3.updateBasket,
        params: { basketSlug, ...payload },
      })
    );
    if (response.ok) {
      dispatch(getBasketLegacy(menuSlug));
    }
    return response;
  };
};

export const getBasketMenuMeal = (basketSlug, mealId, menuSlug) =>
  makeApiRequest({
    requestType: GET_BASKET_MENU_MEAL_V3,
    method: RequestService.v3.getBasketMenuMeal,
    params: { basketSlug, mealId, menuSlug },
  });
